import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	appeal__action__params: 'mw/appeal/action/params',
	appeal__progress__interactions__csv: 'mw/appeal/progress/interactions/csv',
	appeal__customer__csv: 'mw/appeal/customer/csv',
	appeal__customer: 'appeal__customer',
	appeal__comment: 'mw/appeal/comment',
	appeal__comment__post: 'mw/appeal/comment-post',
	appeal__comment__update: 'mw/appeal/comment/update',
	appeal__comment__attach: 'mw/appeal/comment/attach',
	appeal__comment__detach: 'mw/appeal/comment/detach',
	appeal__file__delete: 'mw/appeal/file/delete',
	appeal__file__upload: 'mw/appeal/file/upload',
	appeal__interactions__proof: 'mw/appeal/interactions/proof',
	appeal__filteredType: 'mw/appeal/filteredType',
	appeal: 'mw/appeal',
	appeal__status__list: 'mw/appeal/status/list',
	appeal__dest__list: 'mw/appeal/dest/list',
	appeal__priority__list: 'mw/appeal/priority/list',
	appeal__contactPersons: 'mw/appeal/contactPersons',
	appeal__contacts__save: 'mw/appeal/contacts/save',
	appeal__lock: 'mw/appeal/lock',
	appeal__unlock: 'mw/appeal/unlock',
	appeal__progress__interactions__list: 'mw/appeal/progress/interactions/list',
	appeal__interactions__prooftranscript: 'mw/appeal/interactions/proof-transcript',
	appeal__interactions__prooftranscript_download: 'mw/appeal/interactions/download',
	appeal__opened: 'mw/appeal/opened',
};

export const appealApi = createApi({
	reducerPath: 'mw/appealApi',

	endpoints: (builder) => ({
		appealActionParams: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/action/params?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__action__params],
		}),
		appealProgressInteractionsExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/progress/interactions/list/export',
				body,
			}),
			providesTags: [tags.appeal__progress__interactions__csv],
		}),
		appealCustomer: builder.query({
			query: (body) => ({
				method: 'POST',
				url: `/mw/appeal/customer?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__customer],
		}),
		appealCustomerExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/customer/export',
				body,
			}),
			providesTags: [tags.appeal__customer__csv],
		}),
		appealComment: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/comment?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__comment],
		}),
		appealCommentPost: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/comment',
				body,
				jsonType: true,
			}),
			providesTags: [tags.appeal__comment__post],
		}),
		appealCommentUpdate: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/comment/update',
				body,
				jsonType: true,
			}),
			providesTags: [tags.appeal__comment__update],
			invalidatesTags: [tags.appeal__comment],
		}),
		appealCommentAttach: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/comment/attach',
				body,
				jsonType: true,
			}),
			providesTags: [tags.appeal__comment__attach],
		}),
		appealCommentDetach: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/comment/detach',
				body,
				jsonType: true,
			}),
			providesTags: [tags.appeal__comment__detach],
		}),
		appealFileDelete: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/file/delete',
				body,
			}),
			providesTags: [tags.appeal__file__delete],
		}),
		appealFileUpload: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/file/upload',
				body,
				file: true,
			}),
			providesTags: [tags.appeal__file__upload],
		}),
		appealInteractionsProof: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/interactions/proof?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__interactions__proof],
		}),
		appealInteractionsProofTranscript: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/interactions/proof-transcript?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__interactions__prooftranscript],
		}),
		appealInteractionsProofTranscriptSave: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/interactions/proof-transcript-download?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__interactions__prooftranscript_download],
		}),
		appealFilteredType: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/filteredType?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__filteredType],
		}),
		appeal: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal],
		}),
			appealQuery: builder.query({
				query: (body) => ({
					method: 'GET',
					url: `/mw/appeal?${qs.stringify(body)}`,
				}),
				providesTags: [tags.appeal],
			}),
			appealStatusList: builder.mutation({
				query: (body) => ({
					method: 'GET',
					url: `/mw/appeal/status/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__status__list],
		}),
		appealDestList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/dest/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__dest__list],
		}),
		appealPriorityList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/priority/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__priority__list],
		}),
		appealContactPersons: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/contactPersons?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__contactPersons],
		}),
		appealContactsSave: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal/contacts/save',
				body,
			}),
			providesTags: [tags.appeal__contacts__save],
		}),
		appealLock: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/lock?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__lock],
		}),
		appealUnlock: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/unlock?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__unlock],
		}),
		appealProgressInteractionsList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/appeal/progress/interactions/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.appeal__progress__interactions__list],
		}),
		appealOpened: builder.mutation({
			query: () => ({
				method: 'GET',
				url: '/mw/appeal/opened',
			}),
			providesTags: [tags.appeal__opened],
		}),
	}),
});

export const {
	appealActionParams,
	appealProgressInteractionsExport,
	appealCustomer,
	appealCustomerExport,
	appealComment,
	appealCommentPost,
	appealCommentUpdate,
	appealCommentAttach,
	appealCommentDetach,
	appealFileDelete,
	appealFileUpload,
	appealInteractionsProof,
	appealInteractionsProofTranscript,
	appealInteractionsProofTranscriptSave,
	appealQuery,
	appealFilteredType,
	appeal,
	appealStatusList,
	appealDestList,
	appealPriorityList,
	appealContactPersons,
	appealContactsSave,
	appealLock,
	appealUnlock,
	appealProgressInteractionsList,
	appealOpened,
} = appealApi.endpoints;

export default appealApi;
